module.exports = __webpack_public_path__ + "img/gradient.f3ced0e8.svg";